import { actionCreator } from 'utils';
import {
    LOAD_ROLLS_IN,
    SET_ROLLS_IN_FILTER,
    SET_ROLLS_IN_PAGINATION,
    RESET_ROLLS_IN_FILTERS,
    SET_ROLLS_IN_SORT,
} from '../types/rollInTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 50,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        rollerBarcode: '',
        quality: '',
        width: '',
        height: '',
        creationDate: [],
        status: undefined,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_ROLLS_IN:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_ROLLS_IN, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_ROLLS_IN, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_ROLLS_IN_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_ROLLS_IN_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_ROLLS_IN_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_ROLLS_IN_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RESET_ROLLS_IN_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    default:
        return state;
    }
}
